<template>
  <div class="modal-content">
    <div class="modal-header">
      <h1 class="modal-title fs-5" id="modalPaymentSettingsLabel">{{ $t('cloudPayments.title') }}</h1>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-muted" for="CpPublicId">{{ $t('cloudPayments.publicKey') }}</label>
          <input v-model="cpData.public_key"
                 :class="v$.cpData.public_key.$invalid ? 'border-danger' : ''"
                 class="form-control" type="text" id="CpPublicId">
        </div>
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-muted" for="CpPublicId">{{ $t('cloudPayments.secretKey') }}</label>
          <input v-model="cpData.secret_key"
                 :class="v$.cpData.secret_key.$invalid ? 'border-danger' : ''"
                 class="form-control" type="text" id="CpPublicId">
        </div>
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-muted" for="CpDescription">{{ $t('cloudPayments.description') }}</label>
          <input v-model="cpData.description" class="form-control" type="text" id="CpDescription">
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{ $t('cloudPayments.close') }}</button>
      <button @click="sendSettingsBack"
              :disabled="this.v$.$invalid"
              type="button" class="btn btn-outline-success" data-bs-dismiss="modal">{{ $t('cloudPayments.add') }}</button>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import {required} from "@vuelidate/validators";
export default {
  name: "cloudPayment",
  props:["settings"],
  data() {
    return {
      cpData: {
        public_key: "",
        secret_key: "",
        description: "Оплата с сайта"
      }
    }
  },
  setup () {
    return { v$: useVuelidate({ $autoDirty: true})}
  },
  validations() {
    return {
      cpData: {
        public_key: { required },
        secret_key: { required },
        description: { required }
      }
    }
  },
  methods: {
    sendSettingsBack() {
      this.$emit('getSettings', this.cpData);
    }
  },
  watch: {
    'settings'(e) {
      if (e) {
        this.cpData = e
      }
    }
  }
}
</script>

<style scoped>

</style>
